import {
    FETCHING_ORGANIZATIONS_REQUEST, FETCHING_ORGANIZATIONS_SUCCEEDED, FETCHING_ORGANIZATIONS_FAILED, INVALIDATE_ORGANIZATIONS
  } from 'src/legacy/redux/actions/actionTypes.jsx';

  
  const initialState = {
    loading: false,
    error: null,
    items: [],
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 0,
      totalRecordsCount: 0
    }
  };
  
  function organizationsReducer(state = initialState, action) {
    switch (action.type) {
      case FETCHING_ORGANIZATIONS_REQUEST:
        return Object.assign({}, state, {
          ...state,
          loading: true,
          error: null
        })
      
      case FETCHING_ORGANIZATIONS_SUCCEEDED:
        var items = [];
      
        if (action.payload.currentPage != 0) {
          items = [...state.items, ...action.payload.records];
        } else {
          items = action.payload.records
        }
  
        return Object.assign({}, state, {
          ...state,
          items: items,
          loading: false,
          pagination: {
            currentPage: action.payload.currentPage,
            totalPages: action.payload.totalPages,
            recordsPerPage: action.payload.recordsPerPage,
            totalRecordsCount: action.payload.totalRecordsCount
          }
        })
       
      case FETCHING_ORGANIZATIONS_FAILED:
        return Object.assign({}, state, {
          ...state,
          loading: false,
          error: action.payload
        })
      case  INVALIDATE_ORGANIZATIONS:  
        return Object.assign({}, state, {
            ...state,
            loading: false,
            items: [],
            error: action.payload
        })
      default:
        return state; 
    }
  }
  
  export { organizationsReducer };